// Classes
import { DemographicsReducerState } from "Containers/Filter/Demographics/classes/demographics.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getGenderAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {DemographicsReducerState} demographics - The current state
 * of the Demographics filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getGenderAttributes(demographics)
 */
export const getGenderAttributes = (demographics: DemographicsReducerState) => {
  const attributeArray = [
    (demographics.gender.male && "Male") || undefined,
    (demographics.gender.female && "Female") || undefined,
    (demographics.gender.otherThirdGender && "Non-Binary / Third Gender") || undefined
  ].filter(attributeObject => typeof attributeObject !== "undefined");

  let attributeObject: any;

  if (attributeArray.length > 0) {
    attributeObject = new AttributeObject(
      (attributeArray.length > 1 && `Gender=${attributeArray.length}`) ||
        attributeArray[0],
      "standard",
      attributeArray.length > 1 && attributeArray
    );
  } else {
    attributeObject = undefined;
  }

  return attributeObject;
};
try {
    // @ts-ignore
    getGenderAttributes.displayName = "getGenderAttributes";
    // @ts-ignore
    getGenderAttributes.__docgenInfo = { "description": "", "displayName": "getGenderAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getGenderAttributes.ts#getGenderAttributes"] = { docgenInfo: getGenderAttributes.__docgenInfo, name: "getGenderAttributes", path: "src/shared/containers/Attributes/utilities/getGenderAttributes.ts#getGenderAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }